import React, {Component} from 'react';
import { Link } from 'react-router'

export default class About extends Component {

  render() {
    return (
      <div className="About">
        <h1>About Us</h1>
        <p>Jane’s Colony is an online platform that provides information and educational resources about legal marijuana in the United States. Janes Colony does not produce or sell marijuana. For more information about Jane’s Colony please send us a message via our <Link to="/contact">contact page.</Link></p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/About/About.js